import React, { useCallback, useEffect, useState } from "react";
// import HomeHeader from "../HomeHeader/HomeHeader";
import "./Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
// import MobileNavBar from "../MobileNavBar/MobileNavBar";
import { BrowserRouter as Router } from "react-router-dom";
// import Places from "../../Places/Places";
import { useResizeDetector } from "react-resize-detector";
// import SchedulePanel from "../../SchedulePanel/SchedulePanel";
import ReactHtmlParser from "react-html-parser";
// import HomeContent from "../HomeContent/HomeContent";
import Place from "../../../Models/Place";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../../store/reducer";
import { geocodeGuess } from "../../../Models/ClimateData";
import { useSelector } from "react-redux";
import { urlSchemeToFunctions, buildDocument } from "../../../CommonWeb/Common";
import Common, { Settings, SortByEnum, labelChars, AUTHORIZATION_LEVEL, COLORS } from "../../../Common/Common";
import { DateTime } from "luxon";
import HTMLReader from "../../modals/HTMLReader";
import ReactLoading from "react-loading";

import DataBase from "../../../dataBase/liquidGuides";
import Guide from "../../../Models/Guide";
import PlaceModal from "../../modals/PlaceModal";
import User from "../../../Models/User";
import GooglePlaces from "../../../Models/GooglePlaces";
import InnerHTML from "dangerously-set-html-content";
import DestinationsScreen from "../../modals/DestinationsScreen";

//let htmlDivRef = null;
const Home = ({ setDisplayNone }) => {
  const onResize = useCallback(() => {}, []);
  const [HTMLReaderModal, setHTMLReaderModal] = useState(false);
  const [showDestinationsHint, setShowDestinationsHint] = useState(false);
  const [HTMLContent, setHTMLContent] = useState("");
  const dispatch = useDispatch();
  let LoadingGuide = useSelector((state) => state.LoadingGuide);

  let htmlString = useSelector((state) => state.homeScreen);
  let HTMLTitle = useSelector((state) => state.HTMLTitle);
  let homeScreenKey = useSelector((state) => state.homeScreenKey);
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let ContentFontZoom = useSelector((state) => state.ContentFontZoom);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let GuideEditMode = useSelector((state) => state.GuideEditMode);
  let MobileMode = useSelector((state) => state.MobileMode);
  let CurrentAppScreen = useSelector((state) => state.CurrentAppScreen);
  let GuideFormat = useSelector((state) => state.GuideFormat);
  let user_info = useSelector((state) => state.user_info);
  let ShowHiddenPlaces = useSelector((state) => state.ShowHiddenPlaces);

  // let ScheduleNames = useSelector((state) => state.ScheduleNames);
  const [placeModal, setPlaceModal] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  // Place Details from a link (e.g. a mosaic tile), in mobile mode, with
  // Next/Previous through the places currently shown — the store's filtered
  // list, which after a mosaic tile is that tile's places. Same as a place
  // card's Place Details (2026-10-18). Desktop shows it inline, as the place
  // card does there.
  const storePlaces = useSelector((state) => state.places);
  const [detailsPlaceId, setDetailsPlaceId] = useState(null);
  const [detailsList, setDetailsList] = useState([]);
  const [detailsHtml, setDetailsHtml] = useState("");
  const placeDetailsHtml = (pl) => urlSchemeToFunctions(pl.createPlaceDetailsHTML(pl.Info, null, window.guide_obj, pl.scheduledDates));
  const shownPlaceIds = () => {
    const seen = new Set();
    const ids = [];
    for (const section of storePlaces || []) {
      for (const item of section.data || []) {
        const id = item?.place?.ID;
        if (id == null || seen.has(id)) continue;
        seen.add(id);
        ids.push(id);
      }
    }
    return ids;
  };
  const goToDetailsPlace = (offset) => {
    const i = detailsList.indexOf(detailsPlaceId);
    const nextId = i === -1 ? null : detailsList[i + offset];
    const pl = nextId == null ? null : window.guide_obj.places.getPlace(nextId);
    if (!pl) return;
    setDetailsPlaceId(nextId);
    setDetailsHtml(placeDetailsHtml(pl));
  };

  const { height, ref } = useResizeDetector({
    refreshRate: 1000,
    onResize,
  });

  useEffect(() => {
    const handler = (e) => {
      if (!e.data || e.data.type !== 'mosaicHeight') return;
      const frame = document.getElementById('home-content');
      if (frame) frame.style.height = (e.data.height + 32) + 'px';
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //console.log(height);
  //   if (htmlString == "")

  //   htmlString = "";
  //if (htmlString == "") htmlString = htmlString1;
  //console.log("htmlString Before", htmlString);
  if (typeof htmlString === "undefined" || htmlString === null) htmlString = "";
  //htmlString = urlSchemeToFunctions(htmlString);

  htmlString = urlSchemeToFunctions(htmlString);

  //console.log("htmlString After", htmlString);

  function openAsPageInNewTab(pageContent) {
    let encoded = encodeURIComponent(pageContent);
    let a = document.createElement(`a`);
    a.target = `_blank`;
    a.href = `data:text/html;charset=utf-8,${encoded}`;
    a.style.display = `none`;
    document.body.appendChild(a); // We need to do this,
    a.click(); // so that we can do this,
    document.body.removeChild(a); // after which we do this.
  }

  window.TimeFromYoutube = (search_time, placeID, state, videoLinkOffset) => {
    const place = window.guide_obj.places.getPlace(placeID.toString());
    //console.log("window.TimeFromYoutube place", place);
    if (place === null) return;
    if (state !== 1) return;
    let time = search_time - videoLinkOffset;
    if (time < 0) time = 0;
    const closest = place.findClosestTimeInPath(time);
    if (closest === null) return;
    console.log("*******************TimeFromYoutube", search_time, placeID, state, videoLinkOffset);
    console.log("closest", closest);
    const _MapCenter = { Lat: closest.latitude, Longi: closest.longitude };
    dispatch(slice1Actions.centerMapToLoc({ value: _MapCenter }));
  };

  window.AnimatePath = (place) => {
    //const place = window.guide_obj.places.getPlace(placeID.toString());
    console.log("window.AnimatePath place", place);
    // if (place === null) return;
    // if (state !== 1) return;
    // let time = search_time - videoLinkOffset;
    // if (time < 0) time = 0;
    // const closest = place.findClosestTimeInPath(time);
    // if (closest === null) return;
    // console.log("*******************TimeFromYoutube", search_time, placeID, state, videoLinkOffset);
    // console.log("closest", closest);
    // const _MapCenter = { Lat: closest.latitude, Longi: closest.longitude };
    // dispatch(slice1Actions.centerMapToLoc({ value: _MapCenter }));
  };

  window.UpdateChartCSS = (search_time, placeID, state, videoLinkOffset) => {
    const place = window.guide_obj.places.getPlace(placeID.toString());
    if (place === null) return;
    if (state !== 1) return;
    let max = -9999999999;
    let min = 99999999999;
    const timed_path = place.getTimedPath();
    for (let i = 0; i < timed_path.length; i++) {
      if (timed_path[i].altitude > max) max = timed_path[i].altitude;
      if (timed_path[i].altitude < min) min = timed_path[i].altitude;
    }
    if (max === -9999999999) return "";
    let current = 0;
    const closest = place.findClosestTimeInPath(search_time - videoLinkOffset);
    if (closest !== null) current = closest.altitude.toFixed(2);
    const spread = max - min;
    let html = `<table class="charts-css line show-heading show-labels show-primary-axis show-5-secondary-axes" style="--color: blue;" id="my-chart">
    <caption> Elevation (meters) min:${min.toFixed(2)}, max:${max.toFixed(2)} current:${current}</caption>
    <tbody style="height:150px">\n`;
    let last = 0;
    for (let i = 0; i < timed_path.length; i++) {
      const size = ((timed_path[i].altitude - min) / spread).toFixed(2);
      html += `<tr><td style="--start: ${last}; --size: ${size}"><span class="tooltip"> Altitude: ${timed_path[i].altitude}m <br> Time: ${timed_path[i].elapsed_time}sec </span></td></tr>\n`;
      if (timed_path[i].index === i) html += `<span class="data">|</span> </td></tr>\n`;
      last = size;
    }
    html += `</tbody>
  </table>`;
    //console.log("window.UpdateChart", max, min, spread);
    //console.log("window.UpdateChart", html);
    return html;
  };

  window.UpdateChart = (search_time, placeID, state, videoLinkOffset, onlyLocation) => {
    const place = window.guide_obj.places.getPlace(placeID.toString());
    let data = {
      cubicInterpolationMode: "monotone",
      labels: [],
      datasets: [
        {
          label: "Altitude (meters)",
          data: [],
          borderWidth: 1,
        },
      ],
    };
    let options = {
      tooltips: {
        enabled: false,
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{ display: false }],
        yAxes: [{ display: false }],
      },
    };
    if (place === null) return { data: data, options: options };
    if (state !== 1) return { data: data, options: options };

    const closest = place.findClosestTimeInPath(search_time - videoLinkOffset);

    if (closest !== null) {
      options = {
        plugins: {
          autocolors: false,
          annotation: {
            annotations: {
              point1: {
                type: "point",
                xValue: closest.index,
                yValue: closest.altitude,
                backgroundColor: "rgba(255, 99, 132, 0.25)",
              },
            },
          },
        },
      };
    }
    if (onlyLocation) return { data: data, options: options };
    const timed_path = place.getTimedPath();
    let labels = [];
    let data_data = [];
    for (let i = 0; i < timed_path.length; i++) {
      labels.push("");
      data_data.push(timed_path[i].altitude);
    }
    data.labels = labels;
    data.datasets[0].data = data_data;

    return { data: data, options: options };
  };

  window.StateFromYoutube = (event) => {
    //console.log("*******************StateFromYoutube", event);
  };
  // A cover image that fails to load: hide the broken image; for people who
  // can edit, reveal the tile that links to Edit Guide Info (see
  // Common.coverImageHTML). Viewers who can't edit get nothing — no hole to
  // look at that they can't fix.
  window.coverImageFailed = (img) => {
    try {
      img.onerror = null;
      img.style.display = "none";
      // Anyone with editing turned on: every user can change a guide locally
      // (even a guest or a read-only viewer — they just can't save or copy
      // it), so this follows the same setting as the Edit button.
      const canEdit = GuideEditMode === true;
      const tile = img.parentNode && img.parentNode.querySelector("[data-cover-fix]");
      if (tile && canEdit) tile.style.display = "block";
    } catch (e) {
      /* leave it hidden */
    }
  };
  window.imgFallback = (img) => {
    const PLACEHOLDER = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
    const photo = img.getAttribute("data-photo");
    if (photo && img.src !== photo) {
      img.removeAttribute("data-photo");
      img.src = photo;
    } else {
      img.onerror = null;
      img.src = PLACEHOLDER;
    }
  };

  window.customLink = (url_prop) => {
    console.log("customLink", url_prop);
    let ix = url_prop.lastIndexOf(';');
    let full_url = url_prop.substring(ix+1);
    // "https:example.com" (no //) would be opened as a path relative to this site
    full_url = full_url.replace(/^(https?):(?!\/\/)\/*/i, "$1://");
    console.log("full_url", full_url);
    if (window.guide_obj == null) return;
    if (Common.isExternalClimateUrl(full_url)) {
      // Open the in-app Climate dialog only when the location resolves;
      // otherwise fall back to the original external page.
      // The guide's own place (exact coordinates) comes first; the URL's
      // city/country is only used when the guide has no usable place.
      const loc = Common.guideClimateLocation();
      if (loc) {
        dispatch(slice1Actions.setClimateDialogParams({ value: loc }));
        return;
      }
      const parsed = Common.parseClimateUrlLocation(full_url);
      const openExternal = () => {
        const w = window.open(full_url, "_blank", "noopener,noreferrer");
        if (w) w.focus();
      };
      if (parsed) {
        geocodeGuess(parsed.city, parsed.country)
          .then((g) => {
            if (g) dispatch(slice1Actions.setClimateDialogParams({ value: { city: g.name, country: g.country, lat: g.lat, lon: g.lon } }));
            else openExternal();
          })
          .catch(openExternal);
        return;
      }
    }
    url_prop = url_prop.replace(/%7C/g, "|");
    url_prop = url_prop.replace(";", ":");
    const urlParts = url_prop.split(":");
    console.log("customLink", urlParts);
    const urlType = urlParts[0];
    //setHTMLReaderModal(true);
    let place = null;
    let places = null;
    let placeIDs = null;
    let action = ";";
    let htmlString = "";
    let win = null;
    let _url = "";
    var homeDiv = null;
    switch (urlType) {
      case "https":
        //console.log("https");
        _url = urlParts[0] + ":" + urlParts[1];
        //console.log(_url);
        win = window.open(_url, "_blank");
        if (win) win.focus();

        // win = window.open("about:blank", "", "_blank");
        // win.document.write(_url);
        // win.focus();
        break;
      case "Https":
        _url = urlParts[0] + ":" + urlParts[1];
        //console.log(_url);
        win = window.open(_url, "_blank");
        if (win) win.focus();
        break;
      case "urllink":
        //console.log("urllink", urlParts[1]);
        if (urlParts[1].startsWith("http")) _url = urlParts[1] + ":" + urlParts[2];
        //console.log("urllink", _url);

        if (_url.includes("place_id=")) {
          const parts = _url.split("=");
          console.log("_url", _url);
          GooglePlaces.getMoreDetails(getMoreDetailsCallback, parts[1]);
          return;
        }
        win = window.open(full_url, "_blank");
        //win = window.open("about:blank", "", "_blank");
        //win.document.write(_url);
        if (win) win.focus();
        break;
      case "placemenulink":
        place = window.guide_obj.places.getPlace(urlParts[1]);
        if (place == null) return;
        //console.log("placemenulink", urlParts[1]);
        setSelectedPlace(place);
        setPlaceModal(true);
        // dispatch(slice1Actions.setSelectedPlace({ place: place }));
        // dispatch(slice1Actions.setShowPlaceMenu({ value: true }));
        break;
      case "placelink":
        console.log("placelink", urlParts[1]);
        place = window.guide_obj.places.getPlace(urlParts[1]);
        if (place == null) return;
        if (MobileMode) {
          const ids = shownPlaceIds();
          setDetailsList(ids.includes(place.ID) ? ids : []);
          setDetailsPlaceId(place.ID);
          setDetailsHtml(placeDetailsHtml(place));
          break;
        }
        htmlString = place.createPlaceDetailsHTML(place.Info, null, window.guide_obj, place.scheduledDates);

        htmlString = urlSchemeToFunctions(htmlString);
        dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
        dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        window.location.href = "#home-start";
        homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
        break;
      case "placemoreinfolink":
        place = window.guide_obj.places.getPlace(urlParts[1]);
        if (place == null) return;
        //console.log(place);
        dispatch(slice1Actions.setSelectedPlace({ place: place }));
        let link = place.getFirstHLink();
        if (link !== "") {
          //this.props.nav.navigate("StreetView", { place: null, mode: "url", url_string: link, title: "Place Info" });
          action = link;
          htmlString = `<!DOCTYPE html>
      <html>
        <head>
          <title>StreetView</title>
          <meta http-equiv='Content-Type' content='text/html; charset=utf-8'/>
        </head>
        <body>
          <script type='text/javascript'>
            window.location.href = "${action}";
          </script>
        </body>
      </html>`;
          //win = window.open(htmlString, "_blank");
          win = window.open("about:blank", "", "_blank");
          win.document.write(htmlString);
          win.focus();
          break;
        } else {
          const text = place.Info;
          htmlString = place.createPlaceDetailsHTML(text, null, window.guide_obj, place.scheduledDates);

          htmlString = urlSchemeToFunctions(htmlString);
          dispatch(slice1Actions.setHTMLTitle({ value: "Place Details" }));
          dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
          dispatch(slice1Actions.setShowHTMLReader({ value: true }));
          window.location.href = "#home-start";
          homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
        }
        break;
      case "placeslink":
        placeIDs = urlParts[1].split(",");
        places = window.guide_obj.places.getPlacesFromIDs(placeIDs);
        //console.log(places);
        break;
      case "maplink":
        const parts1 = urlParts[1].replace("%7C", "|");
        const placeParts = parts1.split("|");
        if (placeParts.length < 3) return;
console.log("maplink", placeParts);
        placeIDs = placeParts[0].split(",");
        if (placeParts[0] === "") placeIDs = [];

        let GroupIDs = placeParts[1].split(",");
        if (placeParts[1] === "") GroupIDs = [];
        let CategoryIDs = placeParts[2].split(",");
        if (placeParts[2] === "") CategoryIDs = [];
        places = window.guide_obj.getGroupAndCategoryPlaces(placeIDs, [], []);
        //console.log("CategoryIDs", CategoryIDs);

        let centerOnly = false;
        if (placeParts.length > 3) {
          for (let ci = 3; ci < placeParts.length; ci++) {
            if (placeParts[ci] === "center") centerOnly = true;
          }
        }
        if (!centerOnly) dispatch(slice1Actions.ClearAllFilters());
        if (places.length > 0) 
        {
          if(places.length === 1) {
            dispatch(slice1Actions.setShowHiddenPlace({ value: [places[0]] }));
            dispatch(slice1Actions.setMapCenterPlace({ place: places[0] }));
            if (MobileMode) {
              // Same fix as PlaceModal.js's handleCenterInMap — record
              // where we're jumping from so PlacesHeader.js's back arrow
              // can return here instead of the dead-end "Back" tab
              // (MobileNavBar.js, pops an unrelated HTML-content stack).
              // Found/fixed 2026-09-09.
              dispatch(slice1Actions.pushAppScreen({ value: CurrentAppScreen }));
              dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
            } else {
              dispatch(slice1Actions.centerMapToPlaces({ value: [places[0]] }));
              if (!centerOnly) {
                const mapEl = document.getElementById("map-start");
                if (mapEl) mapEl.scrollIntoView();
              }
            }
            break;
          }
          else
            dispatch(slice1Actions.SetPlacesFilter({ value: places }));
        }
        else if (GroupIDs.length > 0) dispatch(slice1Actions.SetGroupsFilter({ value: GroupIDs }));
        else if (CategoryIDs.length > 0) dispatch(slice1Actions.SetCategoriesFilter({ value: CategoryIDs }));

        if (placeParts.length > 3) {
          for (let i = 3; i < placeParts.length; i++) {
            console.log(placeParts[i]);
            if (placeParts[i] === "Favorites") dispatch(slice1Actions.SetFilterFavorites({ value: true }));
            if (placeParts[i] === "Visited") dispatch(slice1Actions.SetFilterVisited({ value: true }));
            if (placeParts[i] === "NotVisited") dispatch(slice1Actions.SetFilterNotVisited({ value: true }));
            if (placeParts[i] === "MustSee") dispatch(slice1Actions.SetFilterMustSee({ value: true }));
            if (placeParts[i].includes("distance")) {
              const distanceParts = placeParts[i].split("=");
              //const dis = parseFloat(distanceParts[1]);
              //console.log("maplink", distanceParts, distanceParts[1], parseFloat(distanceParts[1]));
              dispatch(slice1Actions.SetDistanceFilter({ value: distanceParts[1] }));
            }
            if (placeParts[i].includes("schedule")) {
              const schedulesParts = placeParts[i].split("=");
              const schedule = schedulesParts[1];
              console.log("maplink, schedule ", schedule);
              const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(schedule);
              let hiddenPlacesToShow = [];
              AllScheduledPlaces.forEach((p) => {
                if (p.Hidden === true) hiddenPlacesToShow.push(p);
              });
              console.log("hiddenPlacesToShow", hiddenPlacesToShow);
              dispatch(slice1Actions.setShowHiddenPlace({ value: hiddenPlacesToShow }));
              dispatch(slice1Actions.setScheduleName({ value: schedule }));
              dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: schedule, value: schedule }] }));
            }
            if (placeParts[i].includes("day=") && parts1.includes("|day=")) {
              const dayParts = placeParts[i].split("=");
              const dayTime = parseInt(dayParts[1]);
              console.log("maplink, schedule ", dayTime);
              // dayTime is UTC midnight of the day's wall-clock date (see
              // Guide.createHTMLItinerary) — read it back with UTC getters, not
              // the browser's local ones, or the displayed day can shift by one.
              const date = DateTime.fromMillis(dayTime, { zone: "utc" });
              const day_string = `${Settings.DAYS[date.weekday % 7]}, ${
                Settings.MONTHS[date.month - 1]
              }, ${date.day}, ${date.year}`;
              const day_entry = {
                label: day_string,
                value: dayTime,
                // id: "9999999",
              };
              console.log("day_entry", day_entry);
              const AllScheduledPlaces = window.guide_obj.getAllScheduledPlaces(ScheduleName, dayTime);
              let hiddenPlacesToShow = [];
              AllScheduledPlaces.forEach((p) => {
                if (p.Hidden === true) hiddenPlacesToShow.push(p);
              });
              console.log("hiddenPlacesToShow", hiddenPlacesToShow);
              dispatch(slice1Actions.setShowHiddenPlace({ value: hiddenPlacesToShow }));
              dispatch(slice1Actions.SetDatesFilter({ value: [day_entry] }));
            }
          }
        }
        if (MobileMode) {
          dispatch(slice1Actions.pushAppScreen({ value: CurrentAppScreen }));
        } else {
          window.location.href = "#map-start";
        }
        dispatch(slice1Actions.setCurrentAppScreen({ value: "Map" }));
        setTimeout(timeoutFunc, 100);
        break;
      case "streetviewlink":
        place = window.guide_obj.places.getPlace(urlParts[1]);
        if (place == null) return;
        action = `http://maps.google.com/maps?q=&layer=c&cbll=${place.Lat},${place.Longi}&cbp=11,0,0,0,0`;
        htmlString = `<!DOCTYPE html>
    <html>
      <head>
        <title>StreetView</title>
        <meta http-equiv='Content-Type' content='text/html; charset=utf-8'/>
      </head>
      <body>
        <script type='text/javascript'>
          window.location.href = "${action}";
        </script>
      </body>
    </html>`;
        win = window.open("about:blank", "", "_blank");
        win.document.write(htmlString);
        win.focus();
        break;
      case "sectionlink":
        let section = window.guide_obj.findSection(urlParts[1]);
        if (section == null) {
          //Alert.alert("section not found");
          return;
        }
        console.log("********************BEFORE", section.html);
        htmlString = urlSchemeToFunctions(section.html);
        console.log("********************AFTER", htmlString);
        dispatch(slice1Actions.setHTMLTitle({ value: section.Title }));
        dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
        dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        window.location.href = "#home-start";
        homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
        // setHTMLReaderModal(true);
        break;
      case "imagelink":
        //console.log(urlParts);
        let Image_url = urlParts[1] + ":" + urlParts[2];
        if (url_prop.includes("https://drive.google.com")) {
          const image_parts = url_prop.split("/");
          Image_url = `https://docs.google.com/uc?export=download&id=${image_parts[5]}`;
        }

        Image_url = Image_url.replace(/%2F/g, "/");
        // Image_url = image_parts[5].replace(/%2F/g, "/")
        // let image_path = image_parts[5].replace(/&amp;/g, "&");
        //console.log("Image_url", Image_url);

        /* <img src="https://firebasestorage.googleapis.com/v0/b/liquidguides-2ce60.appspot.com/o/fb_images%2FE2Fqqu9FWDgTdpOzdKQOKEdo6wA3%2FCupola?alt=media&token=440ef5ef-5a31-47e1-9ce6-bf6ba805bcb0" alt="image" style="width:300px; border-radius:10%; margin:10px;"></img>
<img src="https://firebasestorage.googleapis.com/v0/b/liquidguides-2ce60.appspot.com/o/fb_images%2FE2Fqqu9FWDgTdpOzdKQOKEdo6wA3%2FDuomo_m?alt=media&token=4caafe17-21d0-4c74-bf96-529e94cd0cd6" alt="Image" style="width:600px; border-radius:10%"></img> */

        if (Image_url.includes("https://firebasestorage")) {
          let last_slash = Image_url.lastIndexOf("/");
          if (last_slash !== -1) Image_url = Image_url.substr(0, last_slash) + "%2F" + Image_url.substr(last_slash + 1);
          last_slash = Image_url.lastIndexOf("/");
          if (last_slash !== -1) Image_url = Image_url.substr(0, last_slash) + "%2F" + Image_url.substr(last_slash + 1);
        }
        //Image_url = `https://firebasestorage.googleapis.com/v0/b/liquidguides-2ce60.appspot.com/o/fb_images%2FE2Fqqu9FWDgTdpOzdKQOKEdo6wA3%2FCupola_m?alt=media&token=440ef5ef-5a31-47e1-9ce6-bf6ba805bcb0`;
        htmlString = Place.createImageHTML(Image_url, null, "medium");
        //console.log("*******************Imagelink", htmlString);
        //win = window.open(htmlString, "_blank");
        // win = window.open("about:blank", "", "_blank");
        // win.document.write(htmlString);
        // win.focus();
        console.log("***********BEFORE", htmlString);
        htmlString = urlSchemeToFunctions(htmlString);
        console.log("***********AFTER", htmlString);
        dispatch(slice1Actions.setHTMLTitle({ value: "Image" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
        dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        window.location.href = "#home-start";
        homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
        break;
      case "guidelink":
        console.log("guidelink", urlParts[1]);
        //guideClicked(urlParts[1]);
        window.loadGuide(urlParts[1]);
        dispatch(slice1Actions.setShowHTMLReader({ value: false }));
        break;
      case "schedulelink":
        let scheduleName = urlParts[1];
        scheduleName = scheduleName.replace(/%20/g, " ");
        let schedule = [{ label: scheduleName, value: scheduleName }];
        dispatch(slice1Actions.ClearAllFilters());
        dispatch(slice1Actions.SetSchedulesFilter({ value: schedule }));
        dispatch(slice1Actions.setScheduleName({ value: scheduleName }));
        dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
        if (MobileMode) {
          // Same fix as maplink above — record where we're jumping from so
          // ScheduleHeader.js's back arrow can return here. Found/fixed
          // 2026-09-09.
          dispatch(slice1Actions.pushAppScreen({ value: CurrentAppScreen }));
        } else {
          window.location.href = "#schedule-start";
        }
        dispatch(slice1Actions.setCurrentAppScreen({ value: "Schedule" }));
        setTimeout(timeoutFunc, 100);
        break;
      case "itinerarylink":
        let itineraryName = urlParts[1];
        itineraryName = itineraryName.replace(/%20/g, " ");
        if (itineraryName === "__all_places__") {
          // The mosaic's "All places" tile (Guide.ALL_PLACES_KEY): every
          // place, no group or schedule filter.
          const allHtml = window.guide_obj.createHTMLItinerary(itineraryName, GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
          dispatch(slice1Actions.ClearAllFilters());
          dispatch(slice1Actions.setHTMLTitle({ value: window.guide_obj.allPlacesTileLabel(GuideSettings) }));
          dispatch(slice1Actions.setHTMLToSHow({ value: allHtml }));
          dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
          window.location.href = "#home-start";
          const homeDivAll = document.getElementById("home-content-start");
          if (homeDivAll !== null) homeDivAll.scrollIntoView();
        } else if (itineraryName.endsWith("_gm")) {
          // Mosaic group sub-page: group ID is itineraryName minus "_gm"
          const groupID_gm = itineraryName.slice(0, -3);
          const gmGroup = window.guide_obj.getGroupByID(groupID_gm, "guide");
          const gmHtml = window.guide_obj.createHTMLItinerary(itineraryName, GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
          dispatch(slice1Actions.ClearAllFilters());
          dispatch(slice1Actions.SetGroupsFilter({ value: [groupID_gm] }));
          // If the group has a linked schedule, also set the schedule filter
          if (gmGroup && gmGroup.schedule) {
            dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: gmGroup.schedule, value: gmGroup.schedule }] }));
            dispatch(slice1Actions.setScheduleName({ value: gmGroup.schedule }));
          }
          dispatch(slice1Actions.setHTMLTitle({ value: gmGroup ? gmGroup.name : "" }));
          dispatch(slice1Actions.setHTMLToSHow({ value: gmHtml }));
          dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
          window.location.href = "#home-start";
          var homeDiv3 = document.getElementById("home-content-start");
          if (homeDiv3 !== null) homeDiv3.scrollIntoView();
        } else if (itineraryName.endsWith("_m")) {
          // Legacy _m group or schedule sub-page
          const scheduleName_m = itineraryName.slice(0, -2);
          const subHtml = window.guide_obj.createHTMLItinerary(itineraryName, GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
          dispatch(slice1Actions.ClearAllFilters());
          // Prefer finding a group with matching schedule field; fall back to _m name search
          const subGroup = window.guide_obj.groups.find(g => g.schedule === scheduleName_m && g.mosaic)
            || window.guide_obj.findGroupFromName(itineraryName);
          if (subGroup !== null)
            dispatch(slice1Actions.SetGroupsFilter({ value: [subGroup.id] }));
          dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: scheduleName_m, value: scheduleName_m }] }));
          dispatch(slice1Actions.setScheduleName({ value: scheduleName_m }));
          dispatch(slice1Actions.setHTMLTitle({ value: scheduleName_m }));
          dispatch(slice1Actions.setHTMLToSHow({ value: subHtml }));
          dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
          window.location.href = "#home-start";
          var homeDiv2 = document.getElementById("home-content-start");
          if (homeDiv2 !== null) homeDiv2.scrollIntoView();
        } else {
          // Was routing to the raw Schedule grid instead of actually
          // showing the itinerary — unlike its own _gm/_m sibling branches
          // just above, which correctly build real itinerary HTML via
          // createHTMLItinerary and display it. Fixed to match them
          // exactly: same pattern, same "always reached from within Home's
          // own iframe" assumption (nested content — sections, places,
          // itinerary sub-pages — only ever shows there), so no screen
          // switch is needed, same as those siblings. Found/fixed
          // 2026-09-08, corrected 2026-09-09 after an initial attempt at a
          // separate overlay-dialog mechanism proved worse than reusing
          // this already-working pattern (duplicated the app's existing
          // HTMLStack/MobileNavBar "Back" tab history instead of using it,
          // and broke other screen-jump actions like "Center in Map" that
          // don't know about the new overlay). Reverted that; this is the
          // whole fix now.
          let itinHtml = window.guide_obj.createHTMLItinerary(itineraryName, GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
          if (!/^\s*<!doctype|^\s*<html/i.test(itinHtml)) itinHtml = urlSchemeToFunctions(itinHtml);
          dispatch(slice1Actions.setHTMLTitle({ value: itineraryName }));
          dispatch(slice1Actions.setHTMLToSHow({ value: itinHtml }));
          dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
          window.location.href = "#home-start";
          const homeDiv4 = document.getElementById("home-content-start");
          if (homeDiv4 !== null) homeDiv4.scrollIntoView();
        }
        break;
      case "pdflink": {
        let pdf_url = urlParts[1] + ":" + urlParts[2];
        let pdf_html = "";
        if (pdf_url.startsWith("gdrive:")) {
          const fileId = pdf_url.slice(7);
          pdf_html = `<iframe style="max-width: 100%; width: 100%; height: 800px;"
                        src="https://drive.google.com/file/d/${fileId}/preview"
                        frameborder="0" allowfullscreen="allowfullscreen">
                      </iframe>`;
        } else {
          pdf_html = `<iframe style="max-width: 100%; width: 100%; height: 800px;"
                        src="${pdf_url}"
                        frameborder="0">
                      </iframe>`;
        }
        dispatch(slice1Actions.setHTMLTitle({ value: "PDF" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: pdf_html }));
        dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        window.location.href = "#home-start";
        homeDiv = document.getElementById("home-content-start");
        if(homeDiv !== null) homeDiv.scrollIntoView();
        break;
      }
      case "videolink":
        let video_url = urlParts[1] + ":" + urlParts[2];
        let video_html = "";
        //console.log("videolink: url_prop, video_url", url_prop, video_url);
        if (video_url.startsWith("gdrive:")) {
          const fileId = video_url.slice(7);
          video_html = `<iframe style="max-width: 100%; width: 448px; height: 336px;"
                          src="https://drive.google.com/file/d/${fileId}/preview"
                          frameborder="0" allowfullscreen="allowfullscreen">
                        </iframe>`;
        } else if (video_url.includes("https://www.youtu") || video_url.includes("https://youtu")) {
          let video_url_parts = video_url.split("/");
          let yvideo = video_url_parts[video_url_parts.length - 1];
          yvideo = yvideo.replace("watch?v=", "");
          //autoplay does not work on youtube videos
          //<iframe width="560" height="315" src="https://www.youtube.com/embed/-5v8l5eiyOc?start=508" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

          video_html = `<iframe style="max-width: 100%; width: 448px; height: 336px;"
                          src="https://www.youtube.com/embed/${yvideo}?autoplay=1&mute=1" frameborder="0" allowfullscreen="allowfullscreen">
                      </iframe>`;
        } else if (url_prop.includes("https://drive.google.com")) {
          const video_parts = url_prop.split("/");
          video_url = `https://docs.google.com/uc?export=download&id=${video_parts[5]}`;
          video_html = `<video width="448" height="336" controls autoplay muted>
                      <source src="${video_url}" type="video/mp4">
                        Video format not supported use mp4, WebM or Ogg.
                      </video>`;
        } else {
          let videoType = "video/mp4";
          if (video_url.toUpperCase().endsWith("MP4")) videoType = "video/mp4";
          else if (video_url.toUpperCase().endsWith("WEBM")) videoType = "video/webm";
          else if (video_url.toUpperCase().endsWith("OGG")) videoType = "video/ogg";

          // else {
          //   Alert.alert("Video format not supported use mp4, WebM, Youtube or Ogg.");
          //   return false;
          // }
          video_html = `<video width="448" height="336" controls autoplay muted>
                        <source src="${video_url}" type="${videoType}">
                          Video format not supported use mp4, WebM or Ogg.
                      </video>`;
        }
        //console.log(video_html);
        video_html = urlSchemeToFunctions(video_html);
        dispatch(slice1Actions.setHTMLTitle({ value: "Video" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: video_html }));
        dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        window.location.href = "#home-start";
        homeDiv = document.getElementById("home-content-start");
    if(homeDiv !== null) homeDiv.scrollIntoView();
        // win = window.open("about:blank", "", "_blank");
        // win.document.write(video_html);
        // win.focus();
        break;
      case "audiolink": {
        let audio_url = urlParts[1] + ":" + urlParts[2];
        let audio_html = "";
        if (audio_url.startsWith("gdrive:")) {
          const fileId = audio_url.slice(7);
          audio_html = `<iframe style="max-width: 100%; width: 640px; height: 120px;"
            src="https://drive.google.com/file/d/${fileId}/preview"
            frameborder="0" allowfullscreen="allowfullscreen">
          </iframe>`;
        } else {
          if (audio_url.startsWith("https://drive.google.com")) {
            const audio_parts = audio_url.split("/");
            audio_url = `https://docs.google.com/uc?export=download&id=${audio_parts[5]}`;
          }
          let audioType = "audio/mpeg";
          if (audio_url.toUpperCase().endsWith("WAV")) audioType = "audio/wav";
          else if (audio_url.toUpperCase().endsWith("OGG")) audioType = "audio/ogg";
          else if (audio_url.toUpperCase().endsWith("MP3")) audioType = "audio/mpeg";
          else audioType = "audio/mp4";
          audio_html = `<audio style="max-width: 100%; width: 600px;" controls="controls" controlsList="nodownload" autoplay>
    <source src="${audio_url}" type="${audioType}">
  Audio format not supported use mp3, wav, m4a or ogg.
  </audio>`;
        }

        dispatch(slice1Actions.setHTMLTitle({ value: "Audio" }));
        dispatch(slice1Actions.setHTMLToSHow({ value: audio_html }));
        dispatch(slice1Actions.setShowHTMLReader({ value: true }));
        window.location.href = "#home-start";
        homeDiv = document.getElementById("home-content-start");
        if(homeDiv !== null) homeDiv.scrollIntoView();
        break;
      }
      case "directionslink":
        //console.log("urlParts[1]", urlParts[1]);
        let d_places = urlParts[1].split("|");
        let place_to = window.guide_obj.places.getPlace(d_places[1]);
        if (place_to == null) return;
        let place_from = window.guide_obj.places.getPlace(d_places[0]);
        if (place_from == null) return;
        let waypoints = "";
        _url = `https://www.google.com/maps/dir/?api=1&origin=${place_from.Lat},${place_from.Longi}&destination=${place_to.Lat},${place_to.Longi}${waypoints}`;
        win = window.open(_url, "_blank");
        if (win) win.focus();
        break;

      case "weatherlink":
        place = window.guide_obj.places.getPlace(urlParts[1]);
        if (place == null) return;
        _url = `https://www.wunderground.com/forecast/${place.Lat},${place.Longi}`;

        win = window.open(_url, "_blank");
        if (win) win.focus();

        break;

      case "editcoverlink":
        window.dispatchEvent(new CustomEvent("openGuideInfoEditor"));
        break;

      case "climatelink":
        place = window.guide_obj.places.getPlace(urlParts[1]);
        if (place == null) return;
        // Already has exact coordinates — ClimateDialog skips geocoding
        // when lat/lon are passed directly.
        dispatch(slice1Actions.setClimateDialogParams({
          value: { city: place.City, country: place.Country, lat: place.Lat, lon: place.Longi },
        }));
        break;
      default:
      // code block
    }
  };

  const getMoreDetailsCallback = (place_id, details) => {
    if (details === null) return;
    let hlink = "";
    console.log("getMoreDetailsCallback", details);
    if (typeof details.url != "undefined") {
      if (details.url.includes(";")) {
        const urls = details.url.split(";");
        hlink = `${urls[0]}`;
      } else hlink = `${details.url}`;
    }
    console.log("getMoreDetailsCallback", hlink);
    if (hlink !== "") {
      let win = window.open(hlink, "_blank");
      win.focus();
      return null;
    }
  };

  function guideClicked(guide_info_id) {
    //const guide_info_id = "IQrZiedo7oJWa9GgLR6L";
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    DataBase.readGuideTransaction(guide_info_id, readGuideDataReturnNew, "guest");
  }

  const timeoutFunc = () => {
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const readGuideDataReturnNew = (res) => {
    let GuideObj = null;
    if (res.pass === true) {
      GuideObj = new Guide(res.guide_id);
      const guide_json = res.res.data;
      var guide_obj = JSON.parse(guide_json);
      const decoded = GuideObj.decodeGuideFb(guide_obj, res.infoDoc);
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj = GuideObj;
        dispatch(slice1Actions.setGuide({ guide: "new" }));
      } else {
        console.log("decode failed");
      }
    } else {
      //console.log(res.res);
    }
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  return (
    <Router>
      <div id="a">
        {/* <HomeHeader />
        <Switch>
          <Route exact path="/"> */}
        {/* <HomeContent></HomeContent> */}

        <div className="home-panel" ref={ref}>
          {LoadingGuide ? (
            <div className="loading">
              <ReactLoading type={"spin"} color="#0000ff" height={"10%"} width={"10%"} />
            </div>
          ) : (
            <div style={{ margin: "10px", background: "#FAFAFA" }}>
              <div id="home-content-start"></div>
              {!MobileMode && (window.guide_obj?.places?.placesList || []).length === 0 ? (
                <div className="place-card background-color-yellow">
                  {(window.guide_obj?.destinations || []).length === 0 ? (
                    <p>
                      No destinations yet —{" "}
                      <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => setShowDestinationsHint(true)}>
                        add some
                      </span>
                      {" "}to find places automatically.
                    </p>
                  ) : (
                    <p>
                      Find places for your destinations —{" "}
                      <span
                        style={{ textDecoration: "underline", cursor: "pointer" }}
                        onClick={() => window.dispatchEvent(new CustomEvent("openBuildMyTripWizard", { detail: { pickPlacesAuto: true } }))}
                      >
                        automatically
                      </span>
                      {" "}or{" "}
                      <span
                        style={{ textDecoration: "underline", cursor: "pointer" }}
                        onClick={() => window.dispatchEvent(new CustomEvent("openBuildMyTripWizard", { detail: { pickPlacesAuto: false } }))}
                      >
                        pick myself
                      </span>
                      .
                    </p>
                  )}
                </div>
              ) : null}
              {showDestinationsHint ? <DestinationsScreen onHide={() => setShowDestinationsHint(false)} /> : null}
              {/* <div
                style={{ fontSize: `${ContentFontZoom}%` }}
                dangerouslySetInnerHTML={{ __html: htmlString }}
                className="home-resize-panel"
                id="home-content"
                // ref={htmlDivRef}
              >
              </div> */}
              <iframe
                key={homeScreenKey}
                className="home-resize-panel"
                id="home-content"
                title="Guide Content"
                srcDoc={(() => {
                  const t = htmlString && htmlString.trimStart().toLowerCase();
                  return (t && (t.startsWith('<!doctype') || t.startsWith('<html')))
                    ? htmlString
                    : buildDocument(htmlString, ContentFontZoom);
                })()}
                style={{ border: "none", width: "100%", display: "block", overflow: "hidden" }}
                onLoad={(e) => {
                  const frame = e.target;
                  if (!frame.contentDocument || !frame.contentDocument.body) return;
                  const scrollH = frame.contentDocument.body.scrollHeight;
                  // Set height immediately from measurement; postMessage from mosaic will correct if needed
                  frame.style.height = (scrollH > 80 ? scrollH : Math.round(window.innerHeight * 0.85)) + "px";
                  // For non-mosaic content: watch images and body resize
                  frame.contentDocument.querySelectorAll("img").forEach((img) => {
                    if (!img.complete) img.addEventListener("load", () => {
                      // frame can be gone by the time an async img load fires
                      // (React remounts this iframe with a new key whenever
                      // the guide content changes) — contentDocument is then
                      // null, and .body on that throws uncaught. Found
                      // 2026-09-30 via a real Safari crash: "TypeError: null
                      // is not an object (evaluating
                      // 'frame.contentDocument.body')".
                      if (!frame.isConnected || !frame.contentDocument || !frame.contentDocument.body) return;
                      const h = frame.contentDocument.body.scrollHeight;
                      if (h > parseInt(frame.style.height)) frame.style.height = h + "px";
                    });
                  });
                  if (typeof ResizeObserver !== "undefined") {
                    const ro = new ResizeObserver(() => {
                      // Same stale-frame guard as the img load listener above
                      // — a ResizeObserver isn't automatically disconnected
                      // just because the element it's observing was removed
                      // from a now-replaced iframe's document, so this can
                      // keep firing (and kept crashing, before this guard)
                      // well after the iframe itself is gone. Disconnects
                      // itself once that happens instead of only guarding
                      // the access, so it stops retriggering the browser's
                      // own "ResizeObserver loop completed with undelivered
                      // notifications" warning too. Found 2026-09-30.
                      if (!frame.isConnected || !frame.contentDocument || !frame.contentDocument.body) {
                        ro.disconnect();
                        return;
                      }
                      const h = frame.contentDocument.body.scrollHeight;
                      if (h > 80) frame.style.height = h + "px";
                    });
                    ro.observe(frame.contentDocument.body);
                  }
                }}
              />
              {/* {ReactHtmlParser(htmlString)} */}
            </div>
          )}
        </div>
        {/* <div className="map-panel none">
              <h1>Map Panel</h1>
            </div> */}
        {/* </Route>
          <Route path="/places">
            <Places />
          </Route>
          <Route path="/schedule">
            <SchedulePanel />
          </Route>
        </Switch>
        <MobileNavBar /> */}
        <HTMLReader html={htmlString} show={HTMLReaderModal} onHide={() => setHTMLReaderModal(false)} />
        {detailsPlaceId != null ? (
          <HTMLReader
            html={detailsHtml}
            show={true}
            title="Place Details"
            onHide={() => setDetailsPlaceId(null)}
            onPlaceMenuLink={(id) => {
              const pl = window.guide_obj.places.getPlace(id);
              setDetailsPlaceId(null);
              if (pl) { setSelectedPlace(pl); setPlaceModal(true); }
            }}
            showPaging={detailsList.length > 1}
            canGoPrevious={detailsList.indexOf(detailsPlaceId) > 0}
            canGoNext={detailsList.indexOf(detailsPlaceId) !== -1 && detailsList.indexOf(detailsPlaceId) < detailsList.length - 1}
            onPrevious={() => goToDetailsPlace(-1)}
            onNext={() => goToDetailsPlace(1)}
          />
        ) : null}
        {placeModal ? (
          <PlaceModal
            show={placeModal}
            onHide={() => setPlaceModal(false)}
            name={selectedPlace == null ? "" : selectedPlace.name}
            img={selectedPlace == null ? "" : selectedPlace.Photo_m || selectedPlace.Photo}
            i={selectedPlace == null ? "" : selectedPlace.ID}
            // mainIndex={props.mainIndex}
            id={selectedPlace == null ? "" : selectedPlace.ID}
            place={selectedPlace}
          />
        ) : null}
      </div>
    </Router>
  );
};

export default Home;
